const DEFAULT_MEMORY_USAGE_THRESHOLD = 4000; // log memory usage after reaching 4 GB

export function getMemorySnapshot(threshold = DEFAULT_MEMORY_USAGE_THRESHOLD) {
    const memoryData = process.memoryUsage();
    const formatMemoryUsage = (data: number) => Math.round(((data / 1024) / 1024) * 100) / 100;

    return {
        isOverThreshold: formatMemoryUsage(memoryData.rss) > threshold,
        rss: `${formatMemoryUsage(memoryData.rss)} MB -> Resident Set Size - total memory allocated for the process execution`,
        heapTotal: `${formatMemoryUsage(memoryData.heapTotal)} MB -> total size of the allocated heap`,
        heapUsed: `${formatMemoryUsage(memoryData.heapUsed)} MB -> actual memory used during the execution`,
        external: `${formatMemoryUsage(memoryData.external)} MB -> V8 external memory`,
    };
}

